module.exports = __webpack_public_path__ + "img/no_data.ff4ae1bc.png";